import React from 'react';

import {BaseProps} from "../../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleCompetitorPlaceholder} from "./game-center-header-module.competitor.placeholder";
import styles from "../../styles/game-center-header-placeholder.module.scss";
import classNames from "classnames";
import {PlaceholderWrapperComponent} from "../../../../../../core/components/placeholder/placeholder-wrapper";

export class GameCenterHeaderModulePlaceholderProps extends BaseProps {}

export const GameCenterHeaderModulePlaceholder = ({device, showDescriptionPlaceholder, hideGamesSuggestions}: GameCenterHeaderModulePlaceholderProps) => {

  return (
    <PlaceholderWrapperComponent className={classNames(styles.container, {[styles.small_view]: device?.isSmallView}, {[styles.description_visible]: !showDescriptionPlaceholder})}>
      <div className={classNames(styles.content)}>
        <GameCenterHeaderModuleCompetitorPlaceholder/>
        <div className={classNames(styles.board)}>
          <div className={classNames(styles.top)}/>
          <div className={classNames(styles.center)}>
            <div className={classNames(styles.middle)}/>
            <div className={classNames(styles.bottom_middle)}/>
          </div>
        </div>
        <GameCenterHeaderModuleCompetitorPlaceholder/>
      </div>
    </PlaceholderWrapperComponent>
  )
};
